<template>
	<div class="animate_animated animate__slideInRight">
    <div class="fixed inset-x-0 top-0 z-20">
      <div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80 ">
         <div class="h-1 bg-gradient-to-r from-[#62EC14] to-[#88fa46]"></div>
			<div class="">
				<div class="flex items-center px-4 py-4">
					<div class="w-2/3">
						<div class="flex items-center w-full">
							<a  @click="$route.query.match ? $router.go(-1) : $router.push('/')"><img src="@/assets/back-arrow.svg" alt=""></a>
							<span class="text-base text-content font-medium ml-4">{{ $route.query.match ? 'Matching Properties'  : 'Properties'}}</span>
						</div>
					</div>
					<div class="w-1/3">
              <div class="flex items-center justify-end">
              <a @click="share = true" class="mr-2 relative text-main bg-slate-100 p-2.5 rounded-xl "><Share  class="size-5"/>
                <div v-if="shareSelectedProperty.length > 0"
                  class="absolute w-4 h-4 -right-1 -top-1 bg-black text-white rounded-full items-center flex justify-center font-medium">
                  <span class=" text-xxs block ">{{ shareSelectedProperty.length }}</span></div>
              </a>
              <a @click="$router.push('searchproperties')" class=" text-main bg-slate-100 p-2.5 rounded-xl"><Filter class="size-5"/></a>
            </div>

			
					</div>
				</div>
				<div class="flex px-3 pb-3">
					<div class="flex items-strech w-full gap-2">
						<div class="relative w-full">
							<input type="text" @input="e => bsTerm = e.target.value" :value="bsTerm" name="" id="" placeholder="Search Properties"
								class="border border-inputBorder round-md p-3 w-full z-auto focus:outline-none rounded-xl">
							<button type="button" class="absolute right-0 top-0 m-3" v-if="bsTerm" @click="resetBs">
              <img src="@/assets/close-icon.svg" alt="" class="transform rotate-45"></button>
						</div>

						<div class="bg-primary px-4 flex items-center rounded-xl">
              <button type="button" :disabled="!bsTerm" @click="performBs">
							<img src="@/assets/search-icon-white.svg"   alt="" class=""></button>
						</div>
					</div>
				</div>
			</div>
      </div>
		</div>
<!-- Card-List -->
<div class="pt-16 mt-18 bg-gray-50 min-h-screen px-4">
  <span class="result-Text p-3 text-sm text-main text-opacity-50 block">Showing {{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
    <el-tabs class="tab-wrapper" v-model="currentTabSelected" @tab-change="setCurrentTab">
      <el-tab-pane label="Residential" name="Residential" v-if="shouldShowTab('1')" ></el-tab-pane>
      <el-tab-pane label="Commercial" name="Commercial" v-if="shouldShowTab('2')"></el-tab-pane>
      <el-tab-pane label="Plot" name="Plot" v-if="shouldShowTab('3')"></el-tab-pane>
    </el-tabs>
            <ImageViewer
        :visible="visible"
        :imgs="imgList"
        @hide="handleHide"
      />
    <div class="bg-white p-3 my-3 rounded-xl" v-for="(pl, key) in propertyList" :key="key">
			<div class="grid grid-cols-3 gap-3 ">
				<div class=" w-full h-full relative ">
          <div class="absolute bottom-0 w-full px-2 pointer-events-none text-center" v-if="pl.status">
                  <span class="inline-flex items-center px-2 text-[10px] font-medium justify-center py-1 rounded-lg mb-2 bg-white"
                    >{{pl.status}}</span>
                </div>
                
            <img :src="pl.image_url"  @click="opeLightBox(pl.image_url)" alt="" class="rounded-lg w-full h-full max-h-44 object-cover object-center border-none">

				</div>
				<div class="col-span-2">
             <div class="flex items-center  justify-between">
              <span class="text-xs text-content text-opacity-40 ">{{pl.days_ago == 0 ? 'Today' : pl.days_ago + ' days ago'}}</span>
              <div>
                <input type="checkbox" v-model="shareSelectedProperty" :value="pl" class="sr-only" :id="'share-' + key" />
                <label :for="'share-' + key" :class="[
                    'inline-flex items-center gap-1 px-2 py-1 rounded font-medium text-xs cursor-pointer transition',
                    shareSelectedProperty.includes(pl)
                      ? 'bg-black text-white shadow'
                      : 'bg-slate-100 text-main hover:bg-slate-200'
                  ]" tabindex="0">
                  <Share class="size-4" />
                  <span>Share</span>
                </label>
              </div>
              </div>
         <router-link :to="{ name: 'PropertyDetails',  params: {  uuid: pl.uuid }}">
					<div class="">
						<div class="flex items-center mb-1 justify-between">
							
              <span v-if="created_user" class="text-xs text-black font-medium mr-2 text-opacity-50">{{pl.user_name}}</span>
							<span class="text-[10px] border border-primary text-primary  inline-flex items-center rounded-full px-2 py-0.5" style="line-height: 1;">{{pl.property_for}}</span>
	
						</div>
						<h2 class="text-content text-xs capitalize">{{pl.title}}</h2>
            <div class="flex items-center"><span
                    class="text-main text-xs ">{{ pl.locality }}, {{ pl.city }}</span>
                </div>

					
						<div class="flex items-center gap-2 mt-2 justify-between">
              
              <span class="text-xs text-content font-medium">{{pl.carpet_area || '-'}} sq.ft</span>
              <span class="text-sm text-content font-medium">&#8377; {{ $asINR(priceinLacs(pl.expected_price) ) }}</span>
            
						</div>
					</div>
            </router-link>
             
				</div>
       

			</div>

			<div class="flex items-center p-2 py-3  bg-gradient-to-b from-white to-gray-50 justify-center -mb-3 mt-1" v-if="!$route.query.match & pl.matching_leads_count > 0">
				<div class="w-full">
					<div class="flex items-center w-full justify-center gap-4"  @click="filterMatchesEnquiries(pl)">
            <div class="flex items-center gap-2">

              <span
                class="min-w-6 h-6 bg-success rounded-lg text-white font-semibold text-xs mr-1 flex items-center justify-center px-3">{{pl.matching_leads_count}}</span>
              <span class="text-xs text-content font-medium">Matches</span>
            </div>
            <RightArrow class="size-6 text-content" />
					</div>
				</div>
				<!-- <div class="w-1/2">
					<div class="flex items-center justify-end">
						<a href="" class="mx-4"><img src="@/assets/whatsapp.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/email-icon.svg" alt=""></a>
						<a :href="pl.owner_contact && `tel:${pl.owner_contact}`" v-if="pl.owner_contact" class="mx-4"><img src="@/assets/phone-icon.svg" alt=""></a>
					</div>
				</div> -->
 			</div>
		</div>
		<!-- Add Button -->
		<router-link :to="{ name: 'NewProperty' }" v-if="!$route.query.match" class="fixed bottom-6 right-6 z-50 overflow-hidden group rounded-xl px-4 py-4 flex items-center gap-2 text-white shadow-xl ring-1 ring-white/10 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-500 hover:from-emerald-500 hover:to-teal-500 transition-all duration-300 ease-out hover:scale-105 active:scale-95 shine">
			<img src="@/assets/plus-icon.svg" alt="">
		</router-link>
    <div class="pagination-holder">
              <Pagination v-if="totalPages > 1" v-model="pageNo" :total-pages="totalPages" @update:modelValue="goToPage" />
    </div>
    <Modal v-model="share" header="Share with">
        <div class="flex flex-col ">
          <button
            class="flex items-center gap-3 px-4 py-3 rounded-lg bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 hover:to-[#62EC14]/20 transition text-main font-medium mb-4"
            @click="shareWhatsApp()">
            <WhatsApp class="size-8 " />
            <span class="text-base font-medium">Share via WhatsApp</span>
          </button>
           <div class="flex items-center gap-3 px-4 py-3 rounded-lg  bg-gradient-to-r from-[#00cdac]/10 to-[#62EC14]/10 hover:from-[#00cdac]/20 transition text-main font-medium mb-4">
            <Gmail class="size-8" />
            <a :href="shareMailLink" @click="shareWithGmail()" class="font-medium">Gmail</a>
          </div>
          
        </div>
      </Modal>

  
</div>
	</div>
</template>
<script>
import ImageViewer from '@/components/Common/ImageViewer.vue'
import Modal from '@/components/Common/Modal.vue'
import {paramsFromQuery, preparePropertiesSearchParams, numDifferentiation} from '@/assets/scripts/utility.js';
import Share from '@/components/icons/Share.vue';
import Filter from '@/components/icons/Filter.vue';
import WhatsApp from '@/components/icons/WhatsApp.vue';
import Gmail from '@/components/icons/Gmail.vue';
import RightArrow from '@/components/icons/RightArrow.vue';
export default {
  name: 'properties',
  components: {
    Modal,
    ImageViewer,
    Share,
    Filter,
    WhatsApp,
    Gmail,
    RightArrow
  },
  data () {
    return {
      bsTerm: this.$route.query.bs,
      total: 0,
      currentTabSelected: 'Residential',
      perPage: 0,
      share: false,
      shareSelectedProperty: [],
      propertyList: [],
      matched_lead_detail: [],
      advSearchParams: [],
      imgList: [],
      index: 0,
      shareMailLink: '',
      visible: false,
    }
  },
  watch: {
    $route(to, from){
      this.loadProperties();
    }
  },
  created(){
    this.$store.dispatch('setnewPropertyData', {});
    this.loadProperties()
  },
  methods: {
    shouldShowTab(tabValue) {
      if (!this.propertyKeysList.user_property_type_wise_access || 
          this.propertyKeysList.user_property_type_wise_access.length === 0) {
        return true;
      }
      return this.propertyKeysList.user_property_type_wise_access.includes(tabValue);
    },
    getVisibleTabs() {
      const visibleTabs = [];
      if (this.shouldShowTab("1")) visibleTabs.push('Residential');
      if (this.shouldShowTab("2")) visibleTabs.push('Commercial');
      if (this.shouldShowTab("3")) visibleTabs.push('Plot');
      return visibleTabs;
    },
    setCurrentTab(selectedTab) {
      if (selectedTab) {
        this.currentTabSelected = selectedTab
        this.loadProperties()
      }
    },
    opeLightBox(img_url) {
      this.imgList = img_url
      this.index = 1
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    priceinLacs(value) {
      return numDifferentiation(value)
    },
    shareWhatsApp() {
      let link = ''
      let img_url = ''
      if (this.matched_lead_detail && this.matched_lead_detail.mobile != ''){
        link = `https://api.whatsapp.com/send?phone=+91${this.matched_lead_detail.mobile}&text=`
      }
      else{
        link = 'https://api.whatsapp.com/send?text='
      }
      let url = ''
      this.shareSelectedProperty.forEach(prop_detail => {
        if (prop_detail.image_url) {
          prop_detail.image_url.forEach(img => {
            img_url = img_url + `%F0%9F%96%BC%EF%B8%8F+${img}%0D%0A`
          })
        }
        if (this.propertyKeysList.whatsapp_template_id == 2) {
          let brochure_url = ''
          if (prop_detail.brochure_url) {
            brochure_url = brochure_url + `%F0%9F%96%BC%EF%B8%8F+Brochure:+${prop_detail.brochure_url}%0D%0A`
          }
          url = url + `%F0%9F%8C%8D+++https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${prop_detail.lat}%2C${prop_detail.long}+%0D%0A%F0%9F%91%89+Location+%3A+${prop_detail.locality ? prop_detail.locality : ''}%0D%0A%F0%9F%91%89+Address+%3A+${prop_detail.address ? prop_detail.address : ''}%0D%0A%F0%9F%91%89+Floor+%3A+${prop_detail.floor ? prop_detail.floor : ''}%0D%0A%F0%9F%91%89+Unit+%3A+${prop_detail.unit_no ? prop_detail.unit_no : ''}%0D%0A%F0%9F%91%89+Carpet+Area%3A+${prop_detail.carpet_area}+Sq.Ft%0D%0A%F0%9F%91%89+Buildup+Area%3A+${prop_detail.builtup_area ? prop_detail.builtup_area : ''}+Sq.Ft%0D%0A%F0%9F%91%89+Furnishing +Status%3A+${prop_detail.furnishing_type_id ? prop_detail.furnishing_type_id : ''}%0D%0A%F0%9F%91%89+Furnishing+Details%3A+${prop_detail.no_of_workstations ? prop_detail.no_of_workstations : ''}%0D%0A%F0%9F%91%89+Conference+room%3A+${prop_detail.no_of_conference_room ? prop_detail.no_of_conference_room : ''}+Nos%0D%0A%F0%9F%91%89+Private+Cabin%3A+${prop_detail.no_of_cabins ? prop_detail.no_of_cabins : ''}+Nos%0D%0A%F0%9F%91%89+Car+parks%3A+${prop_detail.parking ? prop_detail.parking : ''}%0D%0A%F0%9F%91%89+Height%3A+${prop_detail.height ? prop_detail.height : ''}%0D%0A%F0%9F%91%89+Frontage%3A+${prop_detail.frontage ? prop_detail.frontage : ''}%0D%0A%F0%9F%91%89+Washroom%3A+${prop_detail.bathroom ? prop_detail.bathroom : ''}%0D%0A${img_url}${brochure_url}+%0D%0A%0D%0ATo+arrange+site+visits%2C+or+to+know+more+details+contact+%3A+%0D%0A%F0%9F%91%A4+${this.userName}%0D%0A%F0%9F%93%B1+${this.userMobile}%0D%0A%F0%9F%93%A7+${this.userEmail}${prop_detail.rera_no ? '%0D%0A%F0%9F%91%89Consultants+Rera+No%3A' + prop_detail.rera_no : ''}%0D%0A%0D%0A`

        } else {
          let title = prop_detail.title ? encodeURIComponent(prop_detail.title) : ''
          url = url + `%F0%9F%8F%A8+Flat+%2F+Apartment+for+${prop_detail.property_for}%0D%0A%F0%9F%91%89+Property+Name+%3A+${title}${prop_detail.expected_price ? '%0D%0A%F0%9F%91%89+Price+%3A+' + prop_detail.expected_price : ''}${prop_detail.configuration ? '%0D%0A%F0%9F%91%89+Bedrooms+%3A+' + prop_detail.configuration: ''}${prop_detail.bathroom ? '%0D%0A%F0%9F%91%89+Bathrooms+%3A+' + prop_detail.bathroom: ''}${prop_detail.furnishing_type_id ? '%0D%0A%F0%9F%91%89+Furniture%3A+' + prop_detail.furnishing_type_id: ''}${prop_detail.builtup_area ? '%0D%0A%F0%9F%91%89+Salable+Area%3A+' + prop_detail.builtup_area + '+Sq.Ft': ''}%0D%0A%F0%9F%91%89+Carpet+Area%3A+${prop_detail.carpet_area}+Sq.Ft%0D%0A%F0%9F%91%89+Location+%3A+${prop_detail.locality ? prop_detail.locality : ''}%2C+${prop_detail.city ? prop_detail.city : ''}${prop_detail.external_comments ? '%0D%0A%F0%9F%91%89+Additional+Information+%3A+' + prop_detail.external_comments: ''}
          %0D%0A%0D%0A%F0%9F%8C%8D+++https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${prop_detail.lat}%2C${prop_detail.long}%0D%0A${img_url}+%0D%0A%0D%0ATo+arrange+site+visits%2C+or+to+know+more+details+contact+%3A+%0D%0A%F0%9F%91%A4+${this.userName}%0D%0A%F0%9F%93%B1+${this.userMobile}%0D%0A%F0%9F%93%A7+${this.userEmail}${prop_detail.rera_no ? '%0D%0A%F0%9F%91%89Consultants+Rera+No%3A' + prop_detail.rera_no : ''}%0D%0A%0D%0A`
        }


      })
      link = link + url
      window.open(link)
    },
    shareWithGmail() {
      let text = '';
      this.shareSelectedProperty.forEach(prop_detail => {
        let title = prop_detail.title ? encodeURIComponent(prop_detail.title) : ''
        text = text + `%F0%9F%8F%A8 Flat %2F Apartment for ${prop_detail.property_for}%0D%0A%F0%9F%91%89 Property Name %3A ${title}%0D%0A%F0%9F%91%89 Price %3A ${prop_detail.expected_price} ${prop_detail.configuration ? '%0D%0A%F0%9F%91%89 Bedrooms %3A' + prop_detail.configuration : ''}${prop_detail.bathroom ? '%0D%0A%F0%9F%91%89 Bathrooms %3A ' + prop_detail.bathroom : ''}${prop_detail.furnishing_type_id ? '%0D%0A%F0%9F%91%89 Furniture%3A ' + prop_detail.furnishing_type_id: ''}${prop_detail.builtup_area ? '%0D%0A%F0%9F%91%89 Salable Area%3A ' + prop_detail.builtup_area + 'Sq.Ft ': ''} %0D%0A%F0%9F%91%89 Carpet Area%3A ${prop_detail.carpet_area}Sq.Ft %0D%0A%F0%9F%91%89 Location %3A ${prop_detail.locality ? prop_detail.locality: ''}%2C ${prop_detail.city ? prop_detail.city: ''} ${prop_detail.external_comments ? '%0D%0A%F0%9F%91%89Additional Information %3A' + prop_detail.external_comments: ''}%0D%0A%0D%0A%F0%9F%91%89 https%3A%2F%2Fwww.google.com%2Fmaps%2Fsearch%2F%3Fapi%3D1%26query%3D${prop_detail.lat}%2C${prop_detail.long} %0D%0A%0D%0ATo arrange site visits%2C or to know more details contact %3A %0D%0A%F0%9F%91%A4 ${this.userName}%0D%0A%F0%9F%93%B1 ${this.userMobile}%0D%0A%F0%9F%93%A7 ${this.userEmail}${prop_detail.rera_no ? '%0D%0A%F0%9F%91%89Consultants era No%3A' + prop_detail.rera_no: ''}%0D%0A%0D%0A`
      })
      let url = ''
      if (this.matched_lead_detail && this.matched_lead_detail.email != ''){
        url = `mailto:${this.matched_lead_detail.email}?Subject=Property Details&body=${text}&ui=2&tf=1&pli=1`;
      } else {
        url = `mailto:?Subject=Property Details&body=${text}&ui=2&tf=1&pli=1`;
      }
      this.shareMailLink = url
    },
    filterMatchesEnquiries(properties) {
      let apiParams = {}
      apiParams['locality_id'] = properties.locality_id
      apiParams['budget_from'] = (properties.expected_price - properties.expected_price*15/100)
      apiParams['budget_upto'] = (properties.expected_price + properties.expected_price*15/100)
      apiParams['transaction_type_id'] = properties.property_for_id
      apiParams['match'] = true
      apiParams['as'] = true
      this.$router.replace({name: 'Enquiry', query: apiParams})
    },
    loadProperties(){
      let queryP = {}
        if(Object.keys(this.advSParams).length > 0){
          queryP["as"] = true
          let searchParams = preparePropertiesSearchParams(this.advSParams);
          for(let key in searchParams){
            queryP[key] = searchParams[key];
          }
          this.advSearchParams = queryP
        }
        if (this.advSearchParams.length > 0){
          paramsFromQuery(queryP, this.advSearchParams);
        }
        else{
          paramsFromQuery(queryP, this.$route.query);
        }
        if (this.currentTabSelected) {
          queryP['selected_tab'] = this.currentTabSelected;
          let data = this.$axios.get('/mobile_crm/properties', {
            params: queryP
          })
          .then(res=>{
            this.propertyList = res.data.proprties;
            this.matched_lead_detail = res.data.matched_lead_detail
            this.perPage = res.data.per_page;
            this.total = res.data.count;
        })
        .catch(err => console.log(err));
        }
    },
    goToPage(pageNo){
      let newQ = {...this.$route.query, pageNo};
      this.$router.replace({query: newQ});
    },
    resetBs(){
      let rQ = this.$route.query
      this.bsTerm = ''
      if(rQ.bs){
        delete rQ.bs;
        let reset = {}
        for(let key in rQ){
          reset[key] = rQ[key];
        }
        reset['reset'] = reset.reset ? (reset.reset == 0 ? 1 : 0) : 1
        this.$router.replace({query: reset})
      }
    },
    performBs(){
      if(this.bsTerm){
        let newQ = {...this.$route.query, bs: this.bsTerm}
        delete newQ.pageNo
        this.$router.replace({query: newQ})
      }
    }
  },
  computed: {
    userName(){
      return localStorage.getItem('property-user-name')
    },
    propertyKeysList(){
      return this.$store.getters.propertyKeys;
    },
    userEmail(){
      return localStorage.getItem('property-user-email')
    },
    userMobile(){
      return localStorage.getItem('property-user-mobile')
    },
    advSParams(){
      return this.$store.getters.advSParams;
    },
    created_user(){
      return this.$store.getters.created_user;
    },
    totalPages(){
      if(this.total === 0 || this.perPage === 0){
        return 0;
      }else{
        return Math.ceil(this.total/this.perPage);
      }
    },
    pageNo: {
      get(){
        let pageNo = this.$route.query.pageNo || 1
        return parseInt(pageNo);
      },
      set(){
        true;
      }
    },
    pageStart(){
      if(this.total === 0){
        return 0;
      }
      return (Math.max(0, (this.pageNo - 1)*this.perPage+1))
    },
    pageEnd(){
      if(this.total === 0){
        return 0;
      }
      return (Math.min(this.total, this.pageNo*this.perPage))
    },
  }
}
</script>
<style scoped>

</style>